import ReactToPrint from "react-to-print";

import React, { Component } from 'react';
import Navigation from '../screens/Navigation.jsx';
import 'react-datepicker/dist/react-datepicker.css';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import axios from 'axios';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MdEdit, MdDelete, MdComment } from "react-icons/md";
import Markdownkatexnew from "./Markdown.js";
import { Modal, Row } from "react-bootstrap";
import { isAuth, isAsignature } from "../helpers/auth.js";

export default class Theme extends Component {
	open = () => this.setState({ showModal: true });
	close = () => this.setState({ showModal: false });

	constructor(props) {
		super(props);
		this.state = {
			showModal: false,
			updatable: false,
			name: props.name,
			status: props.status,
			nombre: "",
			contenido: "",
			tarea: "",
			www: "",
			wwwww: "",
			noww: "",
			ber: "",
			themeall: "",
			fechaexa: new Date(),
			timexa: "2",
			editing: false,
			integers: [],
			tassks: [],
			title: "",
			description: "",
			articulo: { art1: 'el', art2: 'del', art3: 'al' },
			description: "",
			dateb: "",
			datee: "",
			id: "",
			submit: "",
		};
	}

	getNotes = async () => {
		await axios.get(
			`${process.env.REACT_APP_API_URL}/seccions/${this.props.match.params.theme}/${this.props.match.params.curse}`
		).then(res => {
			if (res.data.length === 0) {
				this.createatachTheme()
			} else {
				console.log(res.data.length, res.data[0], "www");
				this.setState({
					id: res.data[0]._id,
					title: res.data[0].title,
					description: res.data[0].description
				})
			}
		}).catch((err) => {
			console.log(err.response.statusText);
			toast.error(`Error To Your Information ${err.response.statusText}`);
			if (err.response.status === 401) { }
		});

	};

	async componentDidMount() {
		// this.timeNow()
		document.title = isAsignature().title
		// this.createatachTheme()
		this.getNotes();
		// console.log(this.props.match.params.id)
		// if (this.props.match.params.id) {
		// 	//console.log(this.props.match.params.id);
		// 	//setCookie("id", this.props.match.params.id);
		// 	//setLocalStorage("id", this.props.match.params.id);
		// } else {
		// 	//removeCookie("id");
		// 	//removeLocalStorage("id");
		// }
	}


	createatachTheme = async () => {
		this.setState({
			isDisabled: "true"
		});
		console.log(this.props.match.params.curse, this.props.match.params.theme)
		await axios.post(`${process.env.REACT_APP_API_URL}/seccions`,
			{
				curse: this.props.match.params.theme,
				idtheme: this.props.match.params.curse,
				title: this.props.location.state.title,
				description: "newwwww",
				dateb: new Date(),
				datee: new Date(),
				wwwww: new Date()
			}).then(res => {
				console.log(res)
			})
		this.getNotes()
	}


	submitTest = async e => {
		e.preventDefault();
		console.log(this.state.title, this.state.description);
		const Data = {
			title: this.props.location.state.title,
			description: this.state.description,
			dateb: this.state.dateb,
			datee: this.state.datee
		};
		await axios.put(`${process.env.REACT_APP_API_URL}/seccions/${this.state.id}`, Data).then(res => {
			this.close()
			console.log(res)
		});
		// await axios.post(`${process.env.REACT_APP_API_URL}/tasks/Updaterestricted_date/${this.props.match.params.theme}`, { dateb: this.state.dateb, datee: this.state.datee }).then(res => {
		// console.log(res)
		// toast.dark('Actualizado correctamente')
		// });
	};

	// timeNow() {
	// 	var str = new Date()
	// 	let day = str.getDate()
	// 	let month = str.getMonth() + 1
	// 	let year = str.getFullYear()
	// 	let hour = str.getHours()
	// 	let mnt = str.getMinutes()
	// 	// let scn = str.getSeconds()
	// 	let format1 = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}T${hour < 10 ? '0' + hour : hour}:${mnt < 10 ? '0' + mnt : mnt}`
	// 	this.state.noww = format1
	// }

	onTodoChange(event) {
		const { name, value } = event.target;
		console.log(name, value);
		this.setState({
			[name]: value
		});
		// this.timeNow()

	}

	calificationsimilar = async () => {
		var ntger = this.state.integers
		//console.log(this.photo.task)
		function calculateSimilaritywww(str1 = "", str2 = "") {
			let longer = str1.trim();
			let shorter = str2.trim();
			// let a1 = longer.toLowerCase().split(" ");
			// let b1 = shorter.toLowerCase().split(" ");
			//let result = a1.every((aa, i) => aa[0] === b1[i][0]);
			if (longer.length < shorter.length) [longer, shorter] = [shorter, longer];
			// var arr = [];
			let count = 0;
			for (var i = 0; i < longer.length; i++) {
				if (shorter && shorter.includes(longer[i])) {
					shorter = shorter.replace(longer[i], "")
					count++
				};
			}
			return {
				score: (count * 100) / longer.length
			}
		}
		var dattes = [];

		for (var j = 0; j < ntger.length; j++) {
			if (ntger[j].Usser[0].tassk.length >= 1) {
				dattes.push(Date.parse(ntger[j].Usser[0].tassk[0].createdAt))
			} else {
				console.log("www")
			}
		}


		for (var k = 0; k < ntger.length; k++) {
			this.charge = k + 1; //console.log(k,  this.charrge)
			if (ntger[k].Usser[0].tassk.length >= 1) {
				var www = [];
				var lenghtt = [];
				var ntgerwww = this.state.integers
				for (var j = 0; j < ntgerwww.length; j++) {
					if (ntgerwww[j].Usser[0].tassk.length >= 1 && ntgerwww[j].Usser[0].tassk[0]._id !== ntger[k].Usser[0].tassk[0]._id) {
						www.push(calculateSimilaritywww(ntgerwww[j].Usser[0].tassk[0].task, ntgerwww[k].Usser[0].tassk[0].task).score);
						lenghtt.push(ntgerwww[j].Usser[0].tassk[0].task.length);
					} else {
						www.push(0);
						lenghtt.push(0);
					}
				}
				var onepoint = (Math.max.apply(Math, dattes) - Math.min.apply(Math, dattes)) / 20
				var alcance = Date.parse(ntger[k].Usser[0].tassk[0].createdAt) - Math.min.apply(Math, dattes)
				const wsum = Object.values(www).reduce((a, b) => a + b, 0)
				var nota = 0.5 * (20 - wsum / (ntger.length - www.filter(w => w === 0).length) * (20 / 100)) + 0.3 * ntgerwww[k].Usser[0].tassk[0].task.length * 20 / Math.max(...lenghtt) + 0.2 * alcance / onepoint
				if (nota) {
					await axios.put(`${process.env.REACT_APP_API_URL}/tasks/${ntger[k].Usser[0].tassk[0]._id}`, { task: ntger[k].Usser[0].tassk[0].task, solution: '', note: Math.round(nota) + '' }).then(res => {
						//console.log(res)
					})
				} else {
					//console.log('sin nota')
				}
				this.setState({
					ber: k + 1
				});
			} else {
				//console.log("www")
			}
		}
		this.getNotes()
	}

	calificationsolution = async () => {
		//this.loading = "false"
		var ntger = this.state.integers
		//console.log(this.state.tassks[1].task)
		// var www = [];
		function calculateSimilaritywww(str1 = "", str2 = "") {
			let longer = str1.trim();
			let shorter = str2.trim();
			// let a1 = longer.toLowerCase().split(" ");
			// let b1 = shorter.toLowerCase().split(" ");
			//let result = a1.every((aa, i) => aa[0] === b1[i][0]);
			if (longer.length < shorter.length) [longer, shorter] = [shorter, longer];
			// var arr = [];
			let count = 0;
			for (var i = 0; i < longer.length; i++) {
				if (shorter && shorter.includes(longer[i])) {
					shorter = shorter.replace(longer[i], "")
					count++
				};
			}
			return {
				score: (count * 100) / longer.length
			}
		}

		for (var k = 0; k < ntger.length; k++) {
			if (ntger[k].Usser[0].tassk.length >= 1) {
				var numero = Number(ntger[k].Usser[0].tassk[0].solution) ? Number(ntger[k].Usser[0].tassk[0].solution) : 0
				var similaroriginal = calculateSimilaritywww(this.state.tassks[numero].task, this.state.tassks[numero].solution).score
				var similar = calculateSimilaritywww(ntger[k].Usser[0].tassk[0].task, this.state.tassks[numero].task).score
				var nota = (similar - similaroriginal) / ((100 - similaroriginal) / 20)

				this.setState({
					ber: k + 1
				});
				//console.log(this.photo.tassks[numero].task,"new")
				if (nota) {
					//this.loading = "false"
					await axios.put(`${process.env.REACT_APP_API_URL}/tasks/${ntger[k].Usser[0].tassk[0]._id}`, { task: ntger[k].Usser[0].tassk[0].task, solution: numero + '', note: Math.round(nota * 1000) / 1000 + '' }).then(res => {
						//console.log(res)
					})
				} else {
					console.log('wwwww')
				}
			} else {
				console.log('www');
			}
		}
		toast.dark('Calificado correctamente')
		this.getNotes()
	}


	calificationsolutionone = async (_id, taskk, solution) => {
		function calculateSimilaritywww(str1 = "", str2 = "") {
			let longer = str1.trim();
			let shorter = str2.trim();
			if (longer.length < shorter.length) [longer, shorter] = [shorter, longer];
			// var arr = [];
			let count = 0;
			for (var i = 0; i < longer.length; i++) {
				if (shorter && shorter.includes(longer[i])) {
					shorter = shorter.replace(longer[i], "")
					count++
				};
			}
			return {
				score: (count * 100) / longer.length
			}
		}
		var similaroriginal = calculateSimilaritywww(this.state.tassks[solution].task, this.state.tassks[solution].solution).score
		var similar = calculateSimilaritywww(taskk, this.state.tassks[solution].task).score
		console.log(this.state.tassks[solution].task, "new")
		var nota = (similar - similaroriginal) / ((100 - similaroriginal) / 20)
		console.log(nota)

		this.loading = "false"
		await axios.put(`${process.env.REACT_APP_API_URL}/tasks/${_id}`, { task: taskk, solution: solution + '', note: Math.round(nota * 1000) / 1000 + '' }).then(res => {
			//console.log(res)
		})
		this.getNotes()
	}

	calificationclean = async () => {
		// var dattes = [];
		var ntger = this.state.integers

		for (var k = 0; k < ntger.length; k++) {
			if (ntger[k].Usser[0].tassk.length >= 1) {
				// var numero = Number(ntger[k].Usser[0].tassk[0].solution) ? Number(ntger[k].Usser[0].tassk[0].solution) : 0
				await axios.put(`${process.env.REACT_APP_API_URL}/tasks/${ntger[k].Usser[0].tassk[0]._id}`, { task: ntger[k].Usser[0].tassk[0].task, solution: ntger[k].Usser[0].tassk[0].solution, note: '' }).then(res => {
					console.log(res)
				})
			} else {
				console.log('www');
			}
		}
		toast.dark('Notas limpiadas correctamente')
		this.getNotes()
	}

	createTask = async (user) => {
		console.log(this.state.themeall.dateb, this.state.themeall.datee)
		await axios.post(`${process.env.REACT_APP_API_URL}/tasks`, { note: "", task: "task", solution: "3", theme: this.state.themeall._id, unidad: this.state.themeall.unidad, curse: this.state.themeall.curse, user: user, dateb: this.state.themeall.dateb, datee: this.state.themeall.datee }).then(res => {
			console.log(res)
		})
		this.getNotes()
	}

	//clean tasks
	cleantasks = async () => {
		if (window.confirm('Desea eliminar las tareas?')) {
			var ntger = this.state.integers
			for (var k = 0; k < ntger.length; k++) {
				if (ntger[k].Usser[0].tassk.length >= 1) {
					console.log(ntger[k].Usser[0].tassk[0]._id)
					await axios.delete(`${process.env.REACT_APP_API_URL}/tasks/${ntger[k].Usser[0].tassk[0]._id}`).then(res => {
						console.log(res)
					})
					//this.loading = "false"
					// this.themesService.deletetask(ntger[k].Usser[0].tassk[0]._id)
					// 	.subscribe(res => {
					// 		this.gettheme()
					// 	})
				} else {
					console.log('www');
				}
			}
			this.getNotes()
		}
	}

	onInputChange = (e) => {
		console.log(e.target.name, e.target.value);
		this.setState({ [e.target.name]: e.target.value })
	};


	cleantaskone = async (_id) => {
		if (window.confirm('Desea eliminar la tarea?')) {
			await axios.delete(`${process.env.REACT_APP_API_URL}/tasks/${_id}`).then(res => {
				console.log(res)
			})
			this.getNotes()
		}
	}

	onSubmitRemove = async () => {
		const response = window.confirm('Deseas eliminar este capítulo?');
		if (response) {
			await axios.delete(`${process.env.REACT_APP_API_URL}/seccions/` + this.state.themeall._id);
			this.getNotes();
			toast.dark('Removido correctamente');
		}
	};


	render() {
		return (
			<>
				<Navigation />
				<div className='container'>
					<div className='container'>
						<ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false} />
						{/* <button onClick={reactToPrintFn}>Imprimir sesión</button> */}
						{/* <button onClick={this.calificationclean()}>Imprimir sesión</button> */}

						{/* <div ref={(refer) => (this.componentRef = refer)}>Export my HTMl component to a PDF File</div>
						<ReactToPrint
							content={() => this.componentRef}
							trigger={() => (
								<button className="btn btn-primary">Print to PDF!</button>
							)}
						/>
						 */}
						{isAuth().rol === '2' ?
							<button className="btn btn-info text-center w-100" onClick={() => { this.open(); this.setState({ option: true, title: '', detail: '' }) }} > Editar </button>
							: ''}

						<h5 className="text-center">
							<span className='ffont h1 text-info'> {this.props.location.state.title}</span> [<span className='ffont h3 text-center text-dark'>{this.props.location.state.unittitle} </span>]
						</h5>

						<Modal show={this.state.showModal} onHide={() => { this.close(); }} animation={false}>
							<div className="modal-header font-weight-bold h5">Actualizar</div>
							<div className="modal-body">
								{/* <div class="mb-3">
									<label for="www" class="form-label">Título</label>
									<input type="text" id="www" className="form-control my-1" placeholder="Título" onChange={this.onInputChange} name="title" value={this.state.title} />
								</div> */}

								<div class="mb-3">
									<label for="wwwww" class="form-label">Detalle (Escriba texto en formato Markdown [<a href="https://www.markdownguide.org/basic-syntax/" target="_blank">Tutorial!</a>])</label>
									<textarea type="text" id="wwwww" className="form-control scroll" placeholder="Contenido" rows="9" name="description" onChange={this.onInputChange} value={this.state.description} required ></textarea>
									<Markdownkatexnew>
										{this.state.description}
									</Markdownkatexnew>
								</div>
							</div>
							<div className="modal-footer d-flex right-content-center">
								<button type="button" className="btn btn-info" data-dismiss="modal" aria-label="Close" onClick={this.submitTest}> Actualizar </button>
								<button type="button" className="btn btn-info" data-dismiss="modal" aria-label="Close" onClick={() => { this.close() }}> Close </button>
							</div>
							{/* </form> */}
						</Modal >

						<Markdownkatexnew>
							{this.state.description}
						</Markdownkatexnew>


						{/* <input defaultValue={this.props.location.state.title} name="title" onChange={e => this.onTodoChange(e)} className="form-control my-3" /> */}

						{/* <div className="btn-group">
							<button className='btn btn-info' onClick={() => { this.setState({ articulo: { art1: 'la', art2: 'de la', art3: 'a la' } }) }}>la</button>
							<button className='btn btn-primary' onClick={() => { this.setState({ articulo: { art1: 'las', art2: 'de las', art3: 'a las' } }) }}>las</button>
							<button className='btn btn-info' onClick={() => { this.setState({ articulo: { art1: 'los', art2: 'de los', art3: 'a los' } }) }}>los</button>
						</div>

						<CKEditor
							editor={ClassicEditor}
							disabled={false}
							data={`<p><strong>PROPÓSITO DE APRENDIZAJE&nbsp;</strong></p><figure class="table"><table><tbody><tr><td><strong>COMPETENCIA</strong></td><td><strong>CAPACIDADES</strong></td><td><strong>CRITERIOS DE EVALUACIÓN</strong></td><td><p><strong>EVIDENCIA/PRODUCTO</strong></p></td><td><strong>INSTRUMENTO</strong></td></tr><tr><td><strong>Explica ${this.state.articulo.art1} ${this.props.location.state.title.toLowerCase().italics().bold().strike()} desde un enfoque moderno</strong></td><td><p>Comprende y usa conocimientos sobre ${this.state.articulo.art1} ${this.props.location.state.title.toLowerCase().italics().bold().strike()} y elementos base que la hace posible.</p><p>Evalúa las implicancias del saber y del quehacer científico y tecnológico.</p></td><td><p>Identifica ${this.state.articulo.art1} ${this.props.location.state.title.toLowerCase().italics().bold().strike()} y explica las relaciones necesarias para producir su impacto.</p><p>Comprende la importancia ${this.state.articulo.art2} ${this.props.location.state.title.toLowerCase().italics().bold().strike()} en la sociedad y explica las posibles consecuencias mediatas favorables.</p><p>Aplica las teorías necesarias para generar objetos asociados ${this.state.articulo.art3} ${this.props.location.state.title.toLowerCase().italics().bold().strike()} que interactúen con los humanos para producir el impacto que coadyuve en desarrollo de sociedad.</p><p>Analiza la información y las noticias sobre inteligencia artificial y utiliza esta información para tomar decisiones en la elaboración objetos asociados ${this.state.articulo.art3} ${this.props.location.state.title.toLowerCase().italics().bold().strike()}</p><p>Participa activamente en discusiones y debates sobre la importancia de las nuevas tecnologías de construcciones de objetos artísticos.</p><p>Colabora con otros en la implementación de tecnologías con objetos producto asociados ${this.state.articulo.art3} ${this.props.location.state.title.toLowerCase().italics().bold().strike()}  y fomenta la cultura de las facetas múltiples.</p></td><td>${this.props.location.state.title.italics().bold().strike()}.</td><td>Rúbrica de evaluación</td></tr><tr><td><strong>ENFOQUES</strong></td><td><strong>VALORES</strong></td><td colspan="3"><strong>ACCIONES O ACTITUDES</strong></td></tr><tr><td><strong>ENFOQUE AMBIENTAL&nbsp;</strong></td><td><strong>Valor(es) Respeto a toda forma de vida</strong></td><td colspan="3"><strong>Docentes y estudiantes promueven estilos de vida en armonía con el ambiente, revalorando los saberes locales y el conocimiento ancestral.</strong></td></tr><tr><td colspan="5"><strong>PRÓPOSITO</strong></td></tr><tr><td colspan="5">El propósito de la sesión de aprendizaje es que los estudiantes aprendan a nuevos enfoques de implicación ${this.state.articulo.art2} ${this.props.location.state.title.toLowerCase().italics().bold().strike()}, comprendan la importancia de trascender factores clásicos ${this.state.articulo.art2} ${this.props.location.state.title.toLowerCase().italics().bold().strike()}, apliquen recursos que desarrollen su entorno y su comunidad, analicen la información y las noticias sobre el avance de las tecnologías y utilicen esta información para tomar decisiones informadas sobre las construcciones ${this.state.articulo.art2} ${this.props.location.state.title.toLowerCase().italics().bold().strike()}, participen activamente en discusiones y debates sobre la importancia ${this.state.articulo.art2} ${this.props.location.state.title.toLowerCase().italics().bold().strike()} utilitarias e interactivas como medida de desarrollo de ciertas características humanas, y colaboren con otros en la implementación de nuevos enfoques en su comunidad y fomenten la cultura de prospección innovadora.</td></tr></tbody></table></figure><p><strong>SECUENCIA DIDÁCTICA</strong></p><figure class="table"><table><tbody><tr><td><strong>MOMENTO</strong></td><td><p><strong>PROCESOS PEDAGÓGICOS</strong></p></td><td><strong>TIEMPO</strong></td></tr><tr><td><strong>INICIO</strong></td><td><p>El docente inicia la sesión recordando los acuerdos de convivencia en el aula y la importancia del trabajo en equipo</p><p>El docente motivará a los estudiantes mostrando un video corto sobre el impacto ${this.state.articulo.art2} ${this.props.location.state.title.toLowerCase().italics().bold().strike()} en una comunidad. Después de ver el video, el docente pedirá a los estudiantes que compartan sus reacciones y pensamientos.</p><p>El docente presentará la pregunta de conflicto cognitivo: ¿Qué medidas de modelos asociados ${this.state.articulo.art3} ${this.props.location.state.title.toLowerCase().italics().bold().strike()} podemos implementar en nuestras comunidades para influir en la sociedad y cómo podemos asegurarnos de que estas interacciones sean efectivas y sostenibles a largo plazo?&nbsp;</p><p>Los estudiantes comparten sus respuestas.&nbsp;</p><p>El docente presentará el propósito de la sesión de aprendizaje: <i>"${this.props.location.state.title.italics().bold().strike()}".</i></p></td><td><strong>15 minutos</strong></td></tr><tr><td><strong>DESARROLLO</strong></td><td><p>Los estudiantes tendrán que pensar en la respuesta y anotarla en una hoja.</p><p>El docente pedirá a los estudiantes que compartan sus respuestas iniciales a la pregunta de indagación central.</p><p>El docente presentará una situación significativa:</p><p><i><strong>Contexto:</strong> Colectivo social que desconoce sobre ${this.state.articulo.art1} ${this.props.location.state.title.toLowerCase().italics().bold().strike()}</i></p><p><i><strong>Problema:</strong> El colectivo social necesita desarrollar comptencias para optimzar procesos asociados ${this.state.articulo.art3} ${this.props.location.state.title.toLowerCase().italics().bold().strike()}</i></p><p><i><strong>Reto</strong>: ¿Instruir al colectivo social con ${this.state.articulo.art1} ${this.props.location.state.title.toLowerCase().italics().bold().strike()}?</i></p><p>El docente presenta una pregunta de indagación central: ¿Cómo pueden los estudiantes diseñar ${this.state.articulo.art1} ${this.props.location.state.title.toLowerCase().italics().bold().strike()} y emergencia para situaciones de contexto en su comunidad y ayudar a resolver situaciones colectivas?</p><p>Los estudiantes trabajarán en grupos para construir un plan de elaboración para resolver conflictos asociados ${this.state.articulo.art3} ${this.props.location.state.title.toLowerCase().italics().bold().strike()} enfocado en su comunidad. Deberán identificar los requerimientos, las medidas de construcción necesarias y cómo procesarlas.</p><p>El docente proporciona actividades y recursos para que los estudiantes puedan responder la pregunta de indagación, como una lectura titulada "${this.props.location.state.title.italics().bold().strike()}". (<strong>ANEXO1</strong>)</p><p>Los estudiantes leerán la lectura proporcionada y responderán preguntas de comprensión lectora relacionadas con el tema de la sesión de aprendizaje.</p><p>Los estudiantes compararán su respuesta inicial a la pregunta de indagación central con la información recolectada de las fuentes indagadas y discutirán en grupos cómo esta información puede mejorar la concepción de la escultura.</p><p>Los estudiantes revisarán sus planes de construcción y harán ajustes basados en la nueva información.</p></td><td><strong>60 minutos</strong></td></tr><tr><td><strong>CIERRE</strong></td><td><p>El docente pedirá a los estudiantes que compartan sus planes de construcción revisados y discutirán en clase las mejores prácticas.</p><p>Los estudiantes aplicarán sus planes de construcción a través de una simulación de un entorno determinado en la que deberán poner en práctica las medidas de construcción que elaboraron en sus planes.</p><p>Los estudiantes realizarán una autoevaluación (<strong>ANEXO2</strong>) de su desempeño durante la simulación y compartirán sus resultados con la clase.</p><p>El docente proporcionará actividades de metacognición para que los estudiantes reflexionen sobre el proceso de aprendizaje, como: Responder preguntas como "¿Qué aprendiste hoy?", "¿Qué te pareció más interesante de la sesión de aprendizaje?" y "¿Qué te pareció más difícil?".</p><p>El docente hará preguntas para realizar una retroalimentación formativa a los estudiantes, como:</p><p>¿Cómo te sentiste durante la sesión de aprendizaje?</p><p>¿Qué estrategias utilizaste para diseñar un plan de recreación y producción para solventar e influir sobre las impresiones sicológicas?</p><p>¿Qué aspectos de la sesión de aprendizaje te gustaría profundizar más?</p><p>¿Cómo podrías aplicar lo que aprendiste en tu vida diaria?</p></td><td><strong>15 minutos</strong></td></tr></tbody></table></figure><p><strong>ANEXO1</strong></p><p><strong>Lectura: "</strong>${this.props.location.state.title.italics().bold().strike()}<strong>"</strong></p>${this.state.wwwww}<p><strong>ANEXO2</strong></p><p><strong>RÚBRICA DE EVALUACIÓN DE AUTOEVALUACIÓN&nbsp;</strong></p><figure class="table"><table><thead><tr><th><strong>Criterios de evaluación</strong></th><th><strong>Sí</strong></th><th><strong>No</strong></th></tr></thead><tbody><tr><td>Identifiqué los efectos ${this.state.articulo.art2} ${this.props.location.state.title.toLowerCase().italics().bold().strike()} asociados con alguna necesidad social y expliqué los procesos de construcción necesarias para producir su impacto de manera eficaz.</td><td></td><td></td></tr><tr><td>Comprendí la importancia de estar preparados para un entorno competitivo y expliqué las posibles consecuencias de la interacción entre ${this.state.articulo.art1} ${this.props.location.state.title.toLowerCase().italics().bold().strike()} y personas de manera variable.</td><td></td><td></td></tr><tr><td>Apliqué las los procesos de contribución necesarias para producir el impacto del producto en mi entorno y en mi comunidad.</td><td></td><td></td></tr><tr><td>Analicé la información y las noticias sobre ${this.state.articulo.art1} ${this.props.location.state.title.toLowerCase().italics().bold().strike()} y utilicé esta información para tomar decisiones informadas sobre las interacciones diversas de los humanos.</td><td></td><td></td></tr><tr><td>Participé activamente en discusiones y debates sobre la importancia ${this.state.articulo.art2} ${this.props.location.state.title.toLowerCase().italics().bold().strike()} relacionados con las nuevas tecnologías.</td><td></td><td></td></tr><tr><td>Colaboré con otros en la implementación de construcción de objetos asociados ${this.state.articulo.art3} ${this.props.location.state.title.toLowerCase().italics().bold().strike()} en mi comunidad y fomenté la cultura de investigación y promoción intelectual.</td><td></td><td></td></tr><tr><td>Evalué mi desempeño durante la simulación y compartí mis resultados con la clase.</td><td></td><td></td></tr></tbody></table></figure><p><strong>ANEXO3</strong></p><p><strong>RÚBRICA DE EVALUACIÓN (${this.props.location.state.title.toUpperCase().italics().bold().strike()})</strong></p><figure class="table"><table><thead><tr><th><strong>Criterios de Evaluación</strong></th><th><strong>Nivel de Desempeño Insuficiente (1)</strong></th><th><strong>Nivel de Desempeño Básico(1.5)</strong></th><th><strong>Nivel de Desempeño Satisfactorio(2)</strong></th><th><strong>Nivel de Desempeño Sobresaliente(2.5)</strong></th><th><strong>CALIFICACIÓN</strong></th></tr></thead><tbody><tr><td>Identificación de necesidades colectivas (20%)</td><td>No identifica correctamente los factores asociados con las necesidades en su comunidad.</td><td>Identifica algunos de los factores asociados con las necesidades en su comunidad.</td><td>Identifica la mayoría de los factores asociados con las necesidades en su comunidad.</td><td>Identifica de manera precisa y completa los factores asociados las necesidades en su comunidad.</td><td></td></tr><tr><td><p>Factores y creatividad</p><p>(20%)</p></td><td>No define de manera clara y completa los criterios y factores en las actividades de construcción e influencia interactiva.</td><td>Define de manera parcial los criterios y factores en las actividades de construcción e influencia interactiva.</td><td>Define de manera clara y completa los roles y responsabilidades de los encargados de liderar las actividades de construcción e influencia interactiva.</td><td>Define de manera clara y completa los roles y responsabilidades de los encargados de liderar las actividades de creación y producción, e incluye roles y responsabilidades adicionales de otros miembros de la comunidad.</td><td></td></tr><tr><td><p>Técnicas y métodos de construcción artística</p><p>(20%)</p></td><td>No diseña medidas adecuadas para producir el impacto ${this.state.articulo.art2} ${this.props.location.state.title.toLowerCase().italics().bold().strike()} en su comunidad.</td><td>Diseña medidas básicas para reducir el impacto ${this.state.articulo.art2} ${this.props.location.state.title.toLowerCase().italics().bold().strike()} en su comunidad.</td><td>Diseña medidas efectivas para reducir el impacto ${this.state.articulo.art2} ${this.props.location.state.title.toLowerCase().italics().bold().strike()} en su comunidad.</td><td>Diseña medidas efectivas y creativas para reducir el impacto ${this.state.articulo.art2} ${this.props.location.state.title.toLowerCase().italics().bold().strike()} en su comunidad, e incluye medidas adicionales de recreación.</td><td></td></tr><tr><td><p>Plan de respuesta y elaboracion</p><p>(20%)</p></td><td>No establece un plan de respuesta y recreación en caso de resultados interactivos en su comunidad.</td><td>Establece un plan básico de respuesta y recreación en caso de resultados interactivos en su comunidad.</td><td>Establece un plan efectivo de respuesta y recreación en caso de resultados interactivos en su comunidad.</td><td>Establece un plan efectivo y detallado de respuesta y elaboración en caso de identificar una necesidad colectivas en su comunidad, e incluye medidas adicionales para influir los daños y restaurar los servicios básicos.</td><td></td></tr><tr><td><p>Comunicación</p><p>(20%)</p></td><td>No establece canales de comunicación efectivos para difundir información relevante sobre ${this.state.articulo.art1} ${this.props.location.state.title.toLowerCase().italics().bold().strike()}</td><td>Establece canales de comunicación básicos para difundir información relevante sobre ${this.state.articulo.art1} ${this.props.location.state.title.toLowerCase().italics().bold().strike()}</td><td>Establece canales de comunicación efectivos para difundir información relevante sobre ${this.state.articulo.art1} ${this.props.location.state.title.toLowerCase().italics().bold().strike()}</td><td>Establece canales de comunicación efectivos y creativos para difundir información relevante sobre ${this.state.articulo.art1} ${this.props.location.state.title.toLowerCase().italics().bold().strike()}</td><td></td></tr></tbody></table></figure>`}
							onReady={editor => {
								console.log('Editor is ready to use!', editor);
							}}
							onChange={(event, editor) => {
								this.setState({
									description: editor.getData()
								});
								console.log(editor.getData());
							}}
							onBlur={(event, editor) => {
								console.log('Blur.', editor.getData());
							}}
							onFocus={(event, editor) => {
								console.log('Focus.', editor);
							}}
						/> */}
						{/* {(new Date(this.state.themeall.datee).toLocaleString()).toISOString()} */}
						{/* {this.state.themeall.datee.toISOString().split('.')[0].replace('T', ' ')} */}
						<div className="container bg-light border border-dark rounded my-3">
							<div className="row p-1 d-flex">
								<div className="col-md-6 p-1">
									<input defaultValue="2024-06-01T14:30:26" name="dateb" onChange={e => this.onTodoChange(e)} className="form-control" type="datetime-local" />
								</div>
								<div className="col-md-6 p-1">
									<input defaultValue={new Date().toISOString().split('T')[0]} name="datee" onChange={e => this.onTodoChange(e)} className="form-control" type="datetime-local" />
								</div>
							</div>
							<button className='btn btn-info w-100' onClick={this.submitTest}>Actualizar campos</button>
							<button className='btn btn-warning w-100' onClick={this.onSubmitRemove}>Remover campo</button>
							{this.state.dateb < this.state.noww && this.state.noww < this.state.datee ?
								<div className="text-warning w-100 text-center">ACTIVADO</div> :
								<div className="text-darck w-100 text-center">NO ACTIVADO</div>
							}
						</div>

						<button className='btn btn-outline-info w-100 my-3' onClick={() => { this.createTask(this.state.themeall.user) }}>Crear tarea</button>

						<div className="row  d-flex justify-content-center">
							{this.state.tassks.map((notew) => (
								<div
									className="my-1 text-center col-md-3 p-1 border rounded"
									key={notew._id}
								>
									<div className="">
										{notew.task.length}--{notew.solution.length}
									</div>
									<div className="border border-success p-1 rounded btn-group w-100">
										<Link
											className="btn w-100 btn-primary"
											to={'/test/' + notew._id}
										>
											Actualizar
										</Link>
										<button className="btn btn-danger w-100" onClick={() => {
											this.cleantaskone(notew._id)
										}}>
											Borrar
										</button>
									</div>
								</div>
							))}
						</div>

						<div className="text-warning w-100 text-center">{this.state.ber}</div>

						<div className="row d-flex justify-content-center bg-light p-1 border rounded">
							<div className="col-md-3 p-1">
								<button className="btn btn-warning w-100" onClick={this.cleantasks}>Limpiar tareas</button>
							</div>
							<div className="col-md-3 p-1">
								<button className="btn btn-info w-100" onClick={this.calificationclean}>Limpiar notas</button>
							</div>
							<div className="col-md-3 p-1">
								<button className="btn btn-outline-primary w-100" onClick={this.calificationsimilar}>Calificar similaridad</button>
							</div>
							{this.state.tassks !== '' ?
								<div className="col-md-3 p-1">
									<button className="btn btn-primary w-100" onClick={this.calificationsolution}>Calificar sesión</button>
								</div>
								: null}
						</div>

						<table>
							<thead>
								<tr>
									<th>N</th>
									<th>Apellidos y nombres</th>
									<th>Nota</th>
									<th>Editors</th>
									<th>nCharacters</th>
									<th>Fecha</th>
								</tr>
							</thead >
							<tbody>
								{this.state.integers.map((note, i) => (
									<tr key={note._id}>
										<td>{i + 1}</td>
										<td>{note.Usser[0].name}
										</td>
										{note.Usser[0].tassk.length === 0 ? <td><button className='btn btn-warning' onClick={() => { this.createTask(note.Usser[0]._id) }}>Crear tarea</button></td> : null}
										{note.Usser[0].tassk.map((notew, ii) => (
											<React.Fragment key={ii}>
												<td>
													{notew.note}
												</td>
												<td>
													<div className="btn-group">
														<Link className="btn btn-outline-secondary" to={'/test/' + notew._id} >
															<MdEdit />
														</Link>
														<button className="btn btn-outline-secondary" onClick={() => { this.cleantaskone(notew._id) }} >
															<MdDelete />
														</button>
														<button className="btn btn-outline-secondary" type="button" data-toggle="collapse" data-target={"#collapseOne" + note._id} aria-expanded="false" onClick={() => { this.calificationsolutionone(notew._id, notew.task, notew.solution) }}>
															<MdComment />
														</button>
													</div>
												</td>
												<td>
													{notew.task.length}
												</td>
												<td>
													{notew.createdAt}
												</td>
											</React.Fragment>
										))}
									</tr>
								))
								}
							</tbody>
						</table>
					</div >
				</div>

			</>)
	}
}

